import { render, staticRenderFns } from "./linode.vue?vue&type=template&id=2a947871&"
import script from "./linode.vue?vue&type=script&lang=js&"
export * from "./linode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports